// STATUS: draft — needs native-speaker check before live
// Spanish visitor messages (task TR1, docs/modules/languages.md s2). Visitor keys only; missing keys fall back to en-GB.
export const esVisitor = {
    'kiosk.pairing.title': 'Configurar este quiosco',
    'kiosk.pairing.hint': 'Introduzca el código del portal de CloudSign.',
    'kiosk.pairing.go': 'Vincular',
    'kiosk.pairing.codeLabel': 'Código de vinculación',
    'kiosk.pairing.checking': 'Comprobando el código…',
    'kiosk.pairing.clear': 'Borrar',
    'kiosk.pairing.back': 'Borrar el último dígito',
    'kiosk.pairing.invalid': 'Ese código no es válido o ha caducado. Solicite uno nuevo.',
    'kiosk.pairing.noNetwork': 'No se pudo conectar con CloudSign. Compruebe la Wi-Fi e inténtelo de nuevo.',
    'kiosk.common.back': 'Atrás',
    'kiosk.common.next': 'Siguiente',
    'kiosk.common.continue': 'Continuar',
    'kiosk.common.cancel': 'Cancelar',
    'kiosk.common.yes': 'Sí',
    'kiosk.common.no': 'No',
    'kiosk.welcome.tap': 'Toque aquí para registrar su entrada o salida',
    'kiosk.welcome.offline': 'Sin conexión: los registros se guardan y se envían más tarde',
    'kiosk.home.title': '¿Qué desea hacer?',
    'kiosk.home.signIn': 'Registrar entrada',
    'kiosk.home.signOut': 'Registrar salida',
    'kiosk.home.scan': 'Escanear mi credencial',
    'kiosk.groups.titleIn': '¿En nombre de quién registra su entrada?',
    'kiosk.groups.titleOut': '¿En nombre de quién registra su salida?',
    'kiosk.groups.hint': 'Elija la opción que mejor le corresponda.',
    'kiosk.groups.repeat': 'Miembros habituales',
    'kiosk.pin.hint': 'Introduzca su PIN de 4 dígitos.',
    'kiosk.pin.entered': '{count} de 4 dígitos introducidos',
    'kiosk.pin.wrong': 'Ese PIN no es correcto. Inténtelo de nuevo.',
    'kiosk.pin.locked': 'Demasiados PIN incorrectos. La introducción de PIN está bloqueada durante unos minutos. Pida ayuda a alguien.',
    'kiosk.pin.clear': 'Borrar',
    'kiosk.pin.back': 'Borrar el último dígito',
    'kiosk.identify.title': 'Busque su nombre',
    'kiosk.identify.placeholder': 'Empiece a escribir su nombre',
    'kiosk.identify.none': 'No se encontró a nadie con ese nombre.',
    'kiosk.identify.addSelf': 'No estoy en la lista',
    'kiosk.addSelf.title': 'Añádase',
    'kiosk.name.title': '¿Cuál es su nombre?',
    'kiosk.name.label': 'Su nombre',
    'kiosk.name.fullNameHint': 'Indique su nombre y apellido.',
    'kiosk.already.message': 'Ya tiene la entrada registrada. ¿Desea registrar la salida?',
    'kiosk.already.signOut': 'Registrar mi salida',
    'kiosk.questions.titleIn': 'Unas preguntas rápidas',
    'kiosk.questions.titleOut': 'Antes de marcharse',
    'kiosk.questions.datePlaceholder': 'YYYY-MM-DD',
    'kiosk.questions.acknowledge': 'Lo he entendido',
    'kiosk.questions.hostSearch': 'Escriba el nombre de la persona a la que visita',
    'kiosk.questions.changeHost': 'Cambiar',
    'kiosk.notices.progress': 'Aviso {n} de {total}',
    'kiosk.notices.accept': 'He leído esto y lo acepto',
    'kiosk.notices.sign': 'Firmar',
    'kiosk.notices.signHere': 'Firme con el dedo, por favor.',
    'kiosk.signature.pad': 'Recuadro de firma',
    'kiosk.signature.clear': 'Borrar firma',
    'kiosk.signature.captured': 'Firma guardada',
    'kiosk.photo.title': 'Foto',
    'kiosk.photo.hint': 'Mire a la cámara y toque el botón.',
    'kiosk.photo.take': 'Hacerme la foto',
    'kiosk.photo.getReady': 'Prepárese…',
    'kiosk.photo.retake': 'Repetir la foto',
    'kiosk.photo.use': 'Usar esta foto',
    'kiosk.photo.skip': 'Omitir la foto',
    'kiosk.photo.failed': 'La foto no funcionó. Inténtelo de nuevo.',
    'kiosk.photo.noCamera': 'La cámara no está disponible. Puede continuar sin foto.',
    'kiosk.photo.privacy': 'Su foto solo se usa para su credencial y para el registro de su visita.',
    'kiosk.badge.title': 'Su credencial',
    'kiosk.badge.ask': '¿Desea una credencial?',
    'kiosk.badge.yes': 'Imprimir mi credencial',
    'kiosk.badge.no': 'No, gracias',
    'kiosk.badge.printing': 'Imprimiendo su credencial…',
    'kiosk.badge.done': 'Recoja su credencial',
    'kiosk.badge.failed': 'Lo sentimos, la credencial no se pudo imprimir. Su entrada está registrada. Pida una credencial en recepción.',
    'kiosk.signout.title': 'Busque su nombre para registrar la salida',
    'kiosk.signout.search': 'Buscar por nombre',
    'kiosk.signout.hiddenHint': 'Por privacidad, los nombres no aparecen en la lista. Escriba su nombre o escanee su credencial.',
    'kiosk.signout.empty': 'No hay nadie registrado.',
    'kiosk.signout.noMatch': 'No se encontró a nadie. Inténtelo de nuevo o escanee su credencial.',
    'kiosk.signout.unnamed': 'Visitante',
    'kiosk.scan.title': 'Escanee su credencial',
    'kiosk.scan.hint': 'Acerque el código QR de su credencial a la cámara.',
    'kiosk.scan.allow': 'Permitir la cámara',
    'kiosk.scan.noCamera': 'La cámara no está disponible. Elija su nombre de la lista.',
    'kiosk.scan.notBadge': 'Esa no es una credencial de CloudSign. Inténtelo de nuevo.',
    'kiosk.scan.notSignedIn': 'Esa credencial no está registrada aquí. Elija su nombre de la lista.',
    'kiosk.finish.inTitle': 'Gracias, {name}',
    'kiosk.finish.inMessage': 'Su entrada está registrada.',
    'kiosk.finish.outTitle': 'Adiós, {name}',
    'kiosk.finish.outMessage': 'Su salida está registrada. ¡Buen viaje!',
    'kiosk.finish.tap': 'Toque para terminar',
    'kiosk.update.title': 'Este quiosco necesita una actualización',
    'kiosk.update.message': 'Este quiosco necesita una actualización antes de poder registrar su entrada. Pregunte en recepción.',
    'kiosk.update.short': 'Necesita actualizarse',
    'kiosk.error.required': 'Responda a esta pregunta, por favor.',
    'kiosk.error.mustAcknowledge': 'Marque la casilla para confirmar.',
    'kiosk.error.nameRequired': 'Escriba su nombre, por favor.',
    'kiosk.error.fullName': 'Indique su nombre y apellido.',
    'kiosk.error.tooLong': 'Esa respuesta es demasiado larga.',
    'kiosk.error.number': 'Introduzca un número.',
    'kiosk.error.wholeNumber': 'Introduzca un número entero.',
    'kiosk.error.range': 'Ese número está fuera del rango permitido.',
    'kiosk.error.email': 'Introduzca una dirección de correo electrónico válida.',
    'kiosk.error.phone': 'Introduzca un número de teléfono válido.',
    'kiosk.error.date': 'Introduzca una fecha como 2026-12-31.',
    'kiosk.error.answerNotAllowed': 'Esa respuesta significa que no puede registrarse aquí. Hable con recepción.',
    'kiosk.print.state.ready': 'La impresora está lista',
    'kiosk.print.state.no_media': 'La impresora se ha quedado sin etiquetas',
    'kiosk.print.state.cover_open': 'La tapa de la impresora está abierta',
    'kiosk.print.state.media_mismatch': 'Hay etiquetas incorrectas cargadas en la impresora',
    'kiosk.print.state.busy': 'La impresora está ocupada',
    'kiosk.print.state.error': 'La impresora ha notificado un problema',
    'kiosk.print.state.unreachable': 'No se puede contactar con la impresora',
    'kiosk.print.state.unknown': 'Se desconoce el estado de la impresora',
    'kiosk.home.expected': 'Me esperan',
    'kiosk.home.scanCode': 'Escanear mi código QR',
    'kiosk.scan.titleCode': 'Escanee su código QR',
    'kiosk.scan.hintCode': 'Acerque a la cámara el código QR de su correo, su tarjeta o su credencial.',
    'kiosk.scan.invalid': 'Ese código QR no es válido aquí. Inténtelo de nuevo o elija su nombre de la lista.',
    'kiosk.scan.notSupported': 'Este quiosco no puede usar ese tipo de código QR. Elija su nombre de la lista.',
    'kiosk.scan.unknownMember': 'Ese código QR no se reconoce en este quiosco. Elija su nombre de la lista.',
    'kiosk.scan.oldCode': 'Ese código QR ha sido sustituido por uno nuevo. Use el más reciente o elija su nombre.',
    'kiosk.scan.notHere': 'Ese código QR no es para este quiosco.',
    'kiosk.scan.notExpected': 'Hoy no esperamos esa visita. Pregunte en recepción.',
    'kiosk.scan.cancelled': 'Esa visita ha sido cancelada. Pregunte en recepción.',
    'kiosk.scan.alreadyArrived': 'Ese código QR ya se ha usado para registrar una entrada.',
    'kiosk.scan.expired': 'Ese código QR ha caducado. Pregunte en recepción.',
    'kiosk.expected.title': '¿Quién es usted?',
    'kiosk.expected.search': 'Empiece a escribir su nombre',
    'kiosk.expected.exactHint': 'Escriba su nombre completo exactamente como nos lo facilitaron.',
    'kiosk.expected.requiredHint': 'Tiene que estar previsto para registrarse aquí. Busque su nombre o escanee su código QR.',
    'kiosk.expected.none': 'No encontramos ese nombre en la lista de hoy. Pregunte en recepción.',
    'kiosk.expected.empty': 'En este momento no se espera a nadie.',
    'kiosk.expected.visiting': 'Visita a {host}',
    'kiosk.expected.required': 'Tiene que estar previsto para registrarse aquí. Pregunte en recepción.',
    'kiosk.signout.outMark': 'Salida',
    'kiosk.signout.outToday': 'Salida registrada hoy',
    'kiosk.hostReply.on_my_way': '{host} va de camino.',
    'kiosk.hostReply.please_wait': '{host} le pide que espere, por favor.',
    'kiosk.hostReply.someone': 'Su anfitrión',
    'kiosk.hostReply.dismiss': 'OK',
    'kiosk.evacuation.notAllowed': 'No se puede iniciar una evacuación desde este quiosco.',
    'kiosk.evacuation.wrongPin': 'Ese PIN no es correcto.',
    'kiosk.evacuation.pinLocked': 'Demasiados PIN incorrectos. Espere unos minutos, por favor.',
    'kiosk.evacuation.startFailed': 'No se pudo iniciar la evacuación. Inténtelo de nuevo.',
    'kiosk.nfc.enrolOffline': 'Este quiosco está sin conexión. Las tarjetas solo se pueden registrar cuando está conectado.',
    'kiosk.nfc.enrolExpired': 'Este registro de tarjeta ha terminado o ha caducado.',
    'kiosk.nfc.enrolFailed': 'No se pudo registrar esa tarjeta. Pruebe con otra.',
    'kiosk.nfc.enrolTapAgain': 'Acerque la tarjeta de nuevo, por favor.',
    'kiosk.common.ok': 'OK',
    'kiosk.welcome.stale': 'Este quiosco lleva mucho tiempo sin conexión. Informe a recepción, por favor.',
    'kiosk.welcome.busy': 'El centro está muy concurrido en este momento. Si viene de visita, informe a recepción, por favor.',
    'kiosk.welcome.evacuation': 'Evacuación',
    'kiosk.home.delivery': 'Vengo a entregar un paquete',
    'kiosk.check.seeReceptionTitle': 'Acuda a recepción, por favor',
    'kiosk.check.warnTitle': 'Antes de continuar',
    'kiosk.full.short': 'El centro está completo',
    'kiosk.full.title': 'El centro está completo',
    'kiosk.full.message': 'En este momento no podemos registrar más visitantes. Acuda a recepción, por favor.',
    'kiosk.induction.subtitle': 'Formación de acceso al centro',
    'kiosk.induction.unavailable': 'La formación de acceso no está disponible en este quiosco. Acuda a recepción, por favor.',
    'kiosk.induction.videoMissing': 'El vídeo todavía no está en este quiosco. Lea el texto de abajo, por favor.',
    'kiosk.induction.pdfNote': 'Lea el texto de la formación de abajo, por favor. Pregunte en recepción si desea el documento.',
    'kiosk.induction.wait': 'Espere {seconds} segundos, por favor',
    'kiosk.induction.startQuiz': 'Empezar las preguntas',
    'kiosk.induction.question': 'Pregunta {n} de {total}',
    'kiosk.induction.chooseMany': 'Elija todas las respuestas correctas.',
    'kiosk.induction.finish': 'Terminar',
    'kiosk.induction.retryTitle': 'Todavía no',
    'kiosk.induction.retryMessage': 'Algunas respuestas no eran correctas. Vuelva a intentar {count}.',
    'kiosk.induction.retryButton': 'Intentar de nuevo',
    'kiosk.permits.title': 'Sus permisos de trabajo',
    'kiosk.permits.unavailable': 'Sus permisos no se pueden mostrar en este momento. Acuda a recepción antes de empezar a trabajar.',
    'kiosk.permits.allAccepted': 'Ha aceptado todos sus permisos.',
    'kiosk.permits.progress': 'Permiso {n} de {total}',
    'kiosk.permits.valid': 'Desde el {from} hasta el {until}',
    'kiosk.permits.conditions': 'Condiciones',
    'kiosk.permits.precautions': 'Precauciones',
    'kiosk.permits.signHere': 'Firme aquí para aceptar, {name}',
    'kiosk.permits.accept': 'Acepto este permiso',
    'kiosk.nfc.blocked': 'Esta tarjeta ha sido bloqueada',
    'kiosk.nfc.unknown': 'Tarjeta no reconocida',
    'kiosk.nfc.enrolTitle': 'Registro de tarjetas',
    'kiosk.nfc.enrolProgress': '{done} de {total} completadas',
    'kiosk.nfc.enrolTapFor': 'Acerque la tarjeta para',
    'kiosk.nfc.enrolHold': 'Acerque la tarjeta a la parte trasera de la tableta.',
    'kiosk.nfc.enrolSaving': 'Guardando…',
    'kiosk.nfc.enrolOk': 'Tarjeta guardada.',
    'kiosk.nfc.enrolDone': 'Todas las tarjetas están registradas',
    'kiosk.nfc.noReader': 'En este quiosco no hay ningún lector de tarjetas activado.',
    'kiosk.evacuation.title': 'EVACUACIÓN',
    'kiosk.evacuation.drillTitle': 'SIMULACRO DE INCENDIO',
    'kiosk.evacuation.startTitle': 'Iniciar una evacuación',
    'kiosk.evacuation.confirmTitle': '¿Iniciar una evacuación?',
    'kiosk.evacuation.confirmMessage': 'Esto avisa a todas las personas del centro y abre el pase de lista.',
    'kiosk.evacuation.confirmStart': 'Iniciar evacuación',
    'kiosk.evacuation.leave': 'Salir del pase de lista',
    'kiosk.evacuation.leaveTitle': 'Introduzca el PIN para salir del pase de lista',
    'kiosk.evacuation.returnBanner': 'Evacuación en curso. Toque para volver al pase de lista.',
    'kiosk.evacuation.offline': 'Sin conexión: sus marcas se guardan y se enviarán cuando vuelva la red.',
    'kiosk.evacuation.localOnly': 'Iniciada en este quiosco sin conexión. Se combinará con el portal cuando vuelva la red.',
    'kiosk.evacuation.countUnaccounted': 'Aún no localizados',
    'kiosk.evacuation.countSafe': 'A salvo',
    'kiosk.evacuation.countMissing': 'Desaparecidos',
    'kiosk.evacuation.countTotal': 'En el centro',
    'kiosk.evacuation.allPoints': 'Todos',
    'kiosk.evacuation.search': 'Buscar por nombre',
    'kiosk.evacuation.onlyOpen': 'Aún no están a salvo',
    'kiosk.evacuation.loading': 'Cargando el pase de lista…',
    'kiosk.evacuation.nobody': 'No hay nadie que mostrar.',
    'kiosk.evacuation.safe': 'A salvo',
    'kiosk.evacuation.markedSafe': 'A SALVO (toque para deshacer)',
    'kiosk.evacuation.missing': 'Desaparecido',
    'kiosk.evacuation.markedMissing': 'DESAPARECIDO (toque para deshacer)',
    'kiosk.evacuation.host': 'Anfitrión: {name}',
    'kiosk.evacuation.check': 'REVISAR',
    'kiosk.evacuation.permits': '{count} permiso(s) abierto(s)',
    'kiosk.contactless.qrLabel': 'Escanee este código con su teléfono para registrarse',
    'kiosk.contactless.scanMe': 'Regístrese con su teléfono',
    'kiosk.courier.whoTitle': '¿Para quién es el paquete?',
    'kiosk.courier.whoHint': 'Escriba unas letras de su nombre.',
    'kiosk.courier.search': 'Nombre de la persona',
    'kiosk.courier.useName': 'Usar «{name}»',
    'kiosk.courier.useNameHint': 'Recepción se lo hará llegar',
    'kiosk.courier.carrierTitle': '¿De qué empresa viene?',
    'kiosk.courier.forName': 'Paquete para {name}',
    'kiosk.courier.other': 'Otra',
    'kiosk.courier.otherLabel': 'Nombre de la empresa',
    'kiosk.courier.countTitle': '¿Cuántos paquetes son?',
    'kiosk.courier.howMany': 'Número de paquetes',
    'kiosk.courier.save': 'Hecho',
    'kiosk.courier.thanks': 'Gracias',
    'kiosk.courier.thanksMessage': 'Hemos avisado a la persona de que su paquete ya ha llegado.',
    'kiosk.support.pinTitle': 'Soporte: introduzca el PIN',
    'kiosk.support.title': 'Soporte',
    'kiosk.support.close': 'Cerrar',
    'kiosk.support.network': 'Red',
    'kiosk.support.online': 'En línea',
    'kiosk.support.offline': 'Sin conexión',
    'kiosk.support.queue': 'Pendientes de envío',
    'kiosk.support.oldest': 'Más antiguo pendiente desde',
    'kiosk.support.none': 'Ninguno',
    'kiosk.support.deadLetters': 'Rechazados por el servidor (no enviados)',
    'kiosk.support.deadHelp': 'Estos elementos han sido rechazados por el servidor y se quedan en este quiosco. Informe a su administrador; la página del dispositivo en el portal muestra el recuento.',
    'kiosk.support.configAge': 'Ajustes actualizados por última vez',
    'kiosk.support.ageUnknown': 'Nunca',
    'kiosk.support.ageMinutes': 'hace {n} minutos',
    'kiosk.support.ageHours': 'hace {n} horas',
    'kiosk.support.ageDays': 'hace {n} días',
    'kiosk.support.nfc': 'Lector de tarjetas',
    'kiosk.support.nfcReady': 'Listo',
    'kiosk.support.nfcOff': 'Desactivado',
    'kiosk.support.nfcNone': 'No instalado',
    'kiosk.support.media': 'Vídeos almacenados',
    'kiosk.support.mediaMb': '{mb} MB',
    'kiosk.support.headcount': 'Personas en el centro (este quiosco)',
    'kiosk.finish.poweredBy': 'Con la tecnología de CloudSign',
    'kiosk.badge.noMedia': 'La impresora de credenciales se ha quedado sin etiquetas. Su entrada está registrada. Informe a recepción, por favor.',
    'kiosk.badge.mediaMismatch': 'La impresora de credenciales tiene cargadas las etiquetas incorrectas. Su entrada está registrada. Informe a recepción, por favor.',
    'kiosk.badge.coverOpen': 'La tapa de la impresora de credenciales está abierta. Su entrada está registrada. Informe a recepción, por favor.',
    'kiosk.member.menuTitle': '¿Qué desea hacer?',
    'kiosk.member.signIn': 'Regístreme',
    'kiosk.member.updatePhoto': 'Actualizar mi foto',
    'kiosk.member.sendInvite': 'Envíeme la invitación a la aplicación',
    'kiosk.memberPhoto.title': 'Actualice su foto',
    'kiosk.memberPhoto.saved': 'Su foto se ha actualizado.',
    'kiosk.memberPhoto.failed': 'No se pudo guardar su foto. Inténtelo de nuevo o pida ayuda en recepción.',
    'kiosk.memberPhoto.offline': 'Este quiosco está sin conexión, así que no se puede actualizar su foto en este momento.',
    'kiosk.memberPhoto.notAllowed': 'Su foto no se puede actualizar en el quiosco. Pregunte en recepción.',
    'kiosk.invite.title': 'Obtenga la aplicación de CloudSign',
    'kiosk.invite.sent': 'Le hemos enviado por correo un enlace para configurar la aplicación. Revise su bandeja de entrada.',
    'kiosk.invite.noEmail': 'No tenemos su dirección de correo electrónico, así que no hemos podido enviar la invitación. Pregunte en recepción.',
    'kiosk.invite.tooMany': 'Hoy ha solicitado demasiadas invitaciones. Inténtelo de nuevo mañana.',
    'kiosk.invite.failed': 'No se pudo enviar la invitación. Inténtelo de nuevo o pida ayuda en recepción.',
    'kiosk.invite.offline': 'Este quiosco está sin conexión, así que no se puede enviar una invitación en este momento.',
    'kiosk.invite.sending': 'Enviando su invitación…',
    'kiosk.language.choose': 'Elija su idioma',
    'kiosk.language.button': 'Idioma',
    'public.language.label': 'Idioma',
    'contactless.thank_you': 'Gracias. Su entrada está registrada.',
    'contactless.thank_you_out': 'Gracias. Su salida está registrada.',
    'contactless.poster.title': 'Escanee para registrarse',
    'contactless.poster.hint': 'Apunte la cámara de su teléfono al código. No necesita ninguna aplicación.',
    'check.safety_check.refused': 'Acuda a recepción antes de registrarse.',
    'check.safety_check.alert': 'Admitido con un aviso a recepción (comprobación de seguridad).',
    'check.compliance.refused': 'Falta un documento obligatorio o ha caducado. Acuda a recepción, por favor.',
    'check.compliance.warned': 'Falta un documento obligatorio o ha caducado.',
    'check.induction.required': 'Complete primero la formación de acceso al centro.',
    'check.capacity.full': 'El centro está completo en este momento. Acuda a recepción, por favor.',
    'check.capacity.warned': 'Registrado mientras el centro superaba su aforo.',
    'check.offline': 'Registrado mientras el quiosco estaba sin conexión.',
};
//# sourceMappingURL=es.js.map